import React from "react";
import { CAL_LINK } from "../../../../config/siteConfig";

export default function HeroSection({
    ctaLabel = "Book a Conversation",
    onPrimaryClick = () => {
        const contact = document.getElementById("contact");
        if (contact) {
            contact.scrollIntoView({ behavior: "smooth" });
        } else {
            window.location.href = "#start-a-conversation";
        }
    }
}) {
    return (
        <section
            aria-labelledby="hero-heading"
            className="px-6 md:px-12 lg:px-36 py-10 md:py-12"
            style={{ backgroundColor: "var(--bg-base)" }}
        >
            <div className="max-w-[900px]">

                {/* SUPPORTING FRAME */}
                <p
                    className="mb-4 text-sm sm:text-base font-medium tracking-wide uppercase"
                    style={{ color: "var(--text-secondary)" }}
                >
                    <span className="text-[var(--color-primary)]">Fix</span> First.{" "}
                    <span className="text-[var(--color-primary)]">Scale</span> Next.
                </p>

                {/* PRIMARY HEADLINE */}
                <h1
                    id="hero-heading"
                    className="font-extrabold tracking-tight text-[2.2rem] sm:text-[3rem] md:text-[3.8rem] leading-tight"
                    style={{ color: "var(--text-primary)" }}
                >
                    Growth problems rarely live in{" "}
                    <span style={{ color: "var(--color-primary)" }}>
                        one function
                    </span>
                    .
                </h1>

                {/* SUBHEAD */}
                <p
                    className="mt-6 max-w-[65ch] text-base sm:text-lg md:text-[1.1rem] leading-relaxed"
                    style={{ color: "var(--text-secondary)" }}
                >
                    I help consumer businesses improve{" "}
                    <strong
                        className="font-semibold"
                        style={{ color: "var(--text-primary)" }}
                    >
                        acquisition, engagement, retention and monetization
                    </strong>
                    . I connect growth, product, data and technology to solve problems end-to-end.
                </p>


                {/* CTA */}
                <div className="mt-10 flex flex-wrap items-center gap-4">
                    <a
                        href={CAL_LINK}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={ctaLabel}
                        className="inline-flex items-center justify-center px-7 py-3 rounded-full text-sm md:text-base font-medium shadow-sm transform transition hover:-translate-y-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 hover:no-underline"
                        style={{
                            backgroundColor: "var(--color-primary)",
                            color: "#ffffff",
                        }}
                    >
                        {ctaLabel}
                    </a>
                </div>

            </div>
        </section>
    );
}
